import { Component, Vue } from 'vue-property-decorator'
@Component
export default class ErrorMessages extends Vue{
  public showToast(message:string, title:string):void{
    Vue.$toast.open({
      message: message,
      type: title === 'SUCCESS' ? 'success' : 'error',
      dismissible: true,
      duration: 5000,
      position: 'bottom-left'
    })
  }
  public showError(err: any): void {
    const openError = (message: string) => {
      Vue.$toast.open({
        message,
        type: 'error',
        dismissible: true,
        duration: 5000,
        position: 'bottom-left'
      });
    };

    if (typeof err === 'string') {
      openError(err);
      return;
    }

    const data = err?.response?.data;
    const fieldErrors = data?.errors;
    if (
      fieldErrors &&
      typeof fieldErrors === 'object' &&
      !Array.isArray(fieldErrors) &&
      Object.keys(fieldErrors).length > 0
    ) {
      Object.keys(fieldErrors).forEach((field) => {
        const msgs = fieldErrors[field];
        const first = Array.isArray(msgs) ? msgs[0] : msgs;
        if (first != null && first !== '') {
          openError(String(first));
        }
      });
      return;
    }

    if (data?.message) {
      openError(String(data.message));
      return;
    }

    openError(err?.message || 'Something went wrong');
  }
  public showErrorArr(errors: Record<any, any>[string]):void{
   const errArr: string[] = [];
    Object.keys(errors).map((field: string) => {
      errArr.push(errors[field][0]);
    });
    errArr.forEach(element => {
      Vue.$toast.open({
        message: element,
        type: 'error',
        dismissible: true,
        duration: 5000,
        position: 'bottom-left'
      });
    })
  }

  public showErrorValidation(errors: Record<any, any>[string]):void{
    const errArr: string[] = [];
     Object.keys(errors).map((field: string) => {
       errArr.push(errors[field]);
     });
     errArr.forEach(element => {
       Vue.$toast.open({
         message: element,
         type: 'error',
         dismissible: true,
         duration: 5000,
         position: 'bottom-left'
       });
     })
   }
  
}
